export class MemberRollCallWrapper {
  constructor(public id: string, public memberIds: string[]){}
  
}

